// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/services/bpm1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/services/bpm10.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/services/bpm11.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.servicesBox_OueterContent__DxcNs , .servicesBox_OueterContent2__SGbCz{
    padding: 100px;
}
.servicesBox_OueterContent__DxcNs{
    background-color: #077d924a;
}

.servicesBox_titelUnderLine__pocmW{
    height: 3px;
    width: 70px;
    border-radius: 3px;
    background-color:#077d92 ;
    margin: 20px 0px;
}
.servicesBox_titelFirsttxt__-Ut1O{
    color:  #097ea8 ;
    letter-spacing: 2px;
    font-weight: 200;
    margin: 20px 0px 5px 20px;
}
.servicesBox_mainHeadertxt__JjSGL{
    font-weight: 800;
    color: #1d1d1d;
}
.servicesBox_contentBodytxt__GK0-4{
    text-align: left;
    justify-content: center;
    align-items: center;
}
.servicesBox_cardAndBodyFlex__NnGlW , .servicesBox_cardAndBodyFlex1__U273b{
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;

}
.servicesBox_serviceImgMainComp__EYF6g{
    position: relative;
    z-index: 0;
}
.servicesBox_serviceCardCmp1__8toNG , .servicesBox_serviceCardCmp2__UyjE0 , .servicesBox_serviceCardCmp3__v5Ybd  {
    height: 400px;
    width: 400px;
    border-radius: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    align-items: center;
    text-align: center;
    padding: 20%;
    /* position: absolute;
    top: 100px;
    left: 50px; */
}
.servicesBox_serviceCardCmp1__8toNG{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.servicesBox_serviceCardCmp2__UyjE0{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.servicesBox_serviceCardCmp3__v5Ybd{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.servicesBox_cardBodyContent__9f9u3{
    margin: 5% 0 5% 5%;
}
.servicesBox_contentFeaturesPoints__om\\+O1{
    margin-left: 50px;
    line-height: 30px;
}

@media (max-width: 1024px){

    .servicesBox_OueterContent__DxcNs, .servicesBox_OueterContent2__SGbCz {
        padding: 50px;
    }
    .servicesBox_serviceCardCmp1__8toNG , .servicesBox_serviceCardCmp2__UyjE0 , .servicesBox_serviceCardCmp3__v5Ybd {
        height: 300px;
        width: 300px;
    }
   
}

@media (max-width : 770px){
    
    .servicesBox_cardAndBodyFlex__NnGlW{
        flex-direction: column;
        align-items: center; 
    }
    .servicesBox_cardAndBodyFlex1__U273b{
        align-items: center; 
        flex-direction: column-reverse; 
    }
    .servicesBox_cardBodyContent__9f9u3{
        margin: 5% 0 0 0;
    }
}
@media (max-width : 480px){
    .servicesBox_OueterContent__DxcNs, .servicesBox_OueterContent2__SGbCz {
        padding: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/servicePages/servicesBox.module.css"],"names":[],"mappings":";;AAEA;IACI,cAAc;AAClB;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;;AAEtB;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ;;iBAEa;AACjB;AACA;IACI,yDAA8D;AAClE;AACA;IACI,yDAA+D;AACnE;AACA;IACI,yDAA+D;AACnE;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;;IAEI;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,YAAY;IAChB;;AAEJ;;AAEA;;IAEI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,mBAAmB;QACnB,8BAA8B;IAClC;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":["\r\n\r\n.OueterContent , .OueterContent2{\r\n    padding: 100px;\r\n}\r\n.OueterContent{\r\n    background-color: #077d924a;\r\n}\r\n\r\n.titelUnderLine{\r\n    height: 3px;\r\n    width: 70px;\r\n    border-radius: 3px;\r\n    background-color:#077d92 ;\r\n    margin: 20px 0px;\r\n}\r\n.titelFirsttxt{\r\n    color:  #097ea8 ;\r\n    letter-spacing: 2px;\r\n    font-weight: 200;\r\n    margin: 20px 0px 5px 20px;\r\n}\r\n.mainHeadertxt{\r\n    font-weight: 800;\r\n    color: #1d1d1d;\r\n}\r\n.contentBodytxt{\r\n    text-align: left;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.cardAndBodyFlex , .cardAndBodyFlex1{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    position: relative;\r\n\r\n}\r\n.serviceImgMainComp{\r\n    position: relative;\r\n    z-index: 0;\r\n}\r\n.serviceCardCmp1 , .serviceCardCmp2 , .serviceCardCmp3  {\r\n    height: 400px;\r\n    width: 400px;\r\n    border-radius: 50%;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    align-items: center;\r\n    text-align: center;\r\n    padding: 20%;\r\n    /* position: absolute;\r\n    top: 100px;\r\n    left: 50px; */\r\n}\r\n.serviceCardCmp1{\r\n    background-image: url(\"../../assets/images/services/bpm1.png\");\r\n}\r\n.serviceCardCmp2{\r\n    background-image: url(\"../../assets/images/services/bpm10.png\");\r\n}\r\n.serviceCardCmp3{\r\n    background-image: url(\"../../assets/images/services/bpm11.png\");\r\n}\r\n\r\n.cardBodyContent{\r\n    margin: 5% 0 5% 5%;\r\n}\r\n.contentFeaturesPoints{\r\n    margin-left: 50px;\r\n    line-height: 30px;\r\n}\r\n\r\n@media (max-width: 1024px){\r\n\r\n    .OueterContent, .OueterContent2 {\r\n        padding: 50px;\r\n    }\r\n    .serviceCardCmp1 , .serviceCardCmp2 , .serviceCardCmp3 {\r\n        height: 300px;\r\n        width: 300px;\r\n    }\r\n   \r\n}\r\n\r\n@media (max-width : 770px){\r\n    \r\n    .cardAndBodyFlex{\r\n        flex-direction: column;\r\n        align-items: center; \r\n    }\r\n    .cardAndBodyFlex1{\r\n        align-items: center; \r\n        flex-direction: column-reverse; \r\n    }\r\n    .cardBodyContent{\r\n        margin: 5% 0 0 0;\r\n    }\r\n}\r\n@media (max-width : 480px){\r\n    .OueterContent, .OueterContent2 {\r\n        padding: 20px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"OueterContent": `servicesBox_OueterContent__DxcNs`,
	"OueterContent2": `servicesBox_OueterContent2__SGbCz`,
	"titelUnderLine": `servicesBox_titelUnderLine__pocmW`,
	"titelFirsttxt": `servicesBox_titelFirsttxt__-Ut1O`,
	"mainHeadertxt": `servicesBox_mainHeadertxt__JjSGL`,
	"contentBodytxt": `servicesBox_contentBodytxt__GK0-4`,
	"cardAndBodyFlex": `servicesBox_cardAndBodyFlex__NnGlW`,
	"cardAndBodyFlex1": `servicesBox_cardAndBodyFlex1__U273b`,
	"serviceImgMainComp": `servicesBox_serviceImgMainComp__EYF6g`,
	"serviceCardCmp1": `servicesBox_serviceCardCmp1__8toNG`,
	"serviceCardCmp2": `servicesBox_serviceCardCmp2__UyjE0`,
	"serviceCardCmp3": `servicesBox_serviceCardCmp3__v5Ybd`,
	"cardBodyContent": `servicesBox_cardBodyContent__9f9u3`,
	"contentFeaturesPoints": `servicesBox_contentFeaturesPoints__om+O1`
};
export default ___CSS_LOADER_EXPORT___;
